import { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import ProviderCommonApi from '../../../../API/provider/common-api';
import { MARKETS_FILTER_DEFAULT, MODES_CONTENT_TABLE, TYPE_BUTTONS } from '../../../../constans';
import { NavTabs, Row, WhiteBlock } from '../../../Basic/Blocks';
import { Button } from '../../../Basic/Buttons';
import { Input, Select } from '../../../Basic/Inputs';
import { Table, TablePagination } from '../../../Basic/Table';
import { Text } from '../../../Basic/WrapsStyle';
import ProviderProductsContextMenu from '../../Elements/ProductsContextMenu';
import ProductsTableHeader from './Header';
import ProductsTableLine from './Line';
import styles from './styles.module.scss';

const FILTER = {
  0: 'all',
  1: 'instock',
  2: 'nullstock',
  3: 'hasdata',
  4: 'errors',
  5: 'outofstock',
  6: 'stopbrand',
  7: 'archive',
};

const STATUSES_MAP = {
  '': 'Не выбран',
  true: 'Заполнена',
  false: 'Не заполнена',
};

const MODES = ['Режим остатков', 'Режим контента', 'Режим вб'];

const DELETE_LIST = [
  { text: 'Не выбрано', value: '' },
  { text: 'Да', value: true },
  { text: 'Нет', value: false },
];

const SKLAD = {
  Москва: 'msk',
  Екатеринбург: 'ekb',
};

const ProviderProductsTable = ({
  providerId,
  isSmallProvider = false,
  isMinPackage = false,
  isCityStocks = false,
  ...props
}) => {
  const [search, setSearch] = useState('');
  const [contentMode, changeMode] = useState(MODES[0]);
  const [status, changeStatus] = useState('');
  const { role } = useSelector((store) => store.user);
  const [isDelete, setIsDelete] = useState(DELETE_LIST[0]);

  const [markets, setMarkets] = useState(MARKETS_FILTER_DEFAULT);
  const [page, setPage] = useState(1);

  const [show, setShow] = useState(50);
  const [byId, setById] = useState({});
  const [ids, setIds] = useState([]);
  const [count, setCount] = useState([]);
  const [countStock, setCountStock] = useState([0, 0, 0, 0, 0, 0]);
  const [tab, setTab] = useState(0);
  const [skladName, setSkladdName] = useState('Не выбран');

  const [productsSelect, setProductsSelect] = useState({});
  const [checkAll, setCheckAll] = useState(false);

  const isAdmin = role === 'owner' || role === 'admin';
  const isContentUser = role === 'user';

  const onChangeTab = (n) => {
    setTab(n);
    setCheckAll(false);
    setProductsSelect({});
  };

  const changeProductSelect = (sku) => {
    console.log(sku);
    if (productsSelect[sku]) {
      const s = productsSelect;
      delete s[sku];
      setProductsSelect({ ...s });
    } else {
      setProductsSelect({ ...productsSelect, [sku]: true });
    }
  };

  const clickCheckAll = (flag) => {
    if (flag) {
      const map_select = {};
      ids.forEach((item) => {
        map_select[byId[item].sku] = true;
      });
      setProductsSelect(map_select);
      setCheckAll(true);
    } else {
      setCheckAll(false);

      setProductsSelect({});
    }
  };

  const params = useMemo(() => {
    return {
      providerId,
      search: search.trim(),
      limit: parseInt(show),
      tab: FILTER[tab],
      markets,
      page,
      skladName: skladName === 'Не выбран' ? undefined : SKLAD[skladName],
      contentFilters: {
        contentStatus: status === '' ? undefined : status,
        isDeleteWb: isDelete.value === '' ? undefined : isDelete.value,
      },
    };
  }, [search, show, providerId, tab, status, isDelete, markets, skladName, page]);

  const loadProducts = async () => {
    ProviderCommonApi.getProductsBySearch({ data: params }).then((r) => {
      const { all, instock, nullstock, errors, hasdata, outofstock, stopbrand, archive } = r.stock;
      setCount(r.count);
      setCountStock([all, instock, nullstock, hasdata, errors, outofstock, stopbrand, archive]);

      const byIds = {};
      const id = r.products.map((item) => item.sku);
      r.products.forEach((item) => (byIds[item.sku] = item));

      setById(byIds);
      setIds(id);
    });
  };

  const onChangePage = (v) => {
    setPage(v);
  };

  const onChange = async (sku, field, value, action) => {
    await ProviderCommonApi.changeProduct({ data: { sku, field, value, action } })
      .then((r) => {
        setById({ ...byId, [r.prodyct.sku]: r.product });
      }).catch(console.log);
  };

  const onChangeMany = async (skus, field, value) => {
    await ProviderCommonApi.changeProducts({ data: { skus, field, value } }).then(() => {
      setCheckAll(false);
      setProductsSelect({});
      loadProducts();
    });
  };

  const onRemove = async (skus) => {
    if (isAdmin) {
      await ProviderCommonApi.removeProducts({ data: { skus } }).then(() => {
        setCheckAll(false);
        setProductsSelect({});
        loadProducts();
      });
    }
  };

  useEffect(() => {
    if (params.providerId) {
      loadProducts().then();
    }
  }, [params]);

  useEffect(() => {
    if (contentMode === MODES[2] && role === 'user') {
      setIsDelete({ text: 'Нет', value: false });
    }
  }, [contentMode, role]);

  return (
    <>
      <WhiteBlock className={styles.search_block}>
        <Row className={styles.navigate_table}>
          <NavTabs
            open_tab={tab}
            tabs={[
              'Все товары',
              'В наличии',
              'Нет в наличии',
              'C данными',
              'С ошибками',
              'Выведено из ассортимента',
              'Стоп бренды',
              'Архив',
            ]}
            isNum={true}
            num={countStock}
            style_tab={styles.style_tab}
            onChange={onChangeTab}
          />
          <div>
            <Select select={contentMode} list={MODES} onSelect={(v) => changeMode(v)} width="150px" />
          </div>
        </Row>

        <Row className={styles.row_input}>
          {Object.keys(productsSelect).length > 0 ? (
            <Row className={styles.row_select}>
              <Row>
                <div className={styles.t_select}>Выбрано товаров: {`${Object.keys(productsSelect).length}`}</div>
                <Button
                  type={TYPE_BUTTONS.RED}
                  style={{ marginLeft: '15px', marginRight: '15px' }}
                  onClick={() => {
                    setCheckAll(false);
                    setProductsSelect({});
                  }}
                >
                  Очистить выбор
                </Button>
                <ProviderProductsContextMenu
                  removeProducts={() => onRemove(Object.keys(productsSelect))}
                  archiveProducts={() => onChangeMany(Object.keys(productsSelect), 'is_archive', true)}
                  UnarchiveProducts={() => onChangeMany(Object.keys(productsSelect), 'is_archive', false)}
                  stopbrandProducts={() => onChangeMany(Object.keys(productsSelect), 'is_stop_brand', true)}
                  UnstopbrandProducts={() => onChangeMany(Object.keys(productsSelect), 'is_stop_brand', false)}
                  MarkProducts={() => onChangeMany(Object.keys(productsSelect), 'is_chzn', true)}
                  UnmarkProducts={() => onChangeMany(Object.keys(productsSelect), 'is_chzn', false)}
                  isArchive={FILTER[tab] === 'archive'}
                  isStopbrand={FILTER[tab] === 'stopbrand'}
                />
              </Row>
            </Row>
          ) : (
            <Input value={search} onBlur={(v) => setSearch(v)} onClickEnter={(v) => setSearch(v)} label="Поиск" />
          )}
        </Row>
        <Text style={{ marginTop: '15px' }}>{`Найдено: ${count}`}</Text>

        <Row spaceBetween={true}>
          <Row>
            <Select
              label="Показать на странице"
              select={show}
              list={['50', '100', '150', '200', '500', '1000']}
              onSelect={(v) => setShow(v)}
              width="150px"
              style={{ marginRight: '20px' }}
            />
            {isCityStocks && (
              <Select
                label="Склад"
                select={skladName}
                list={['Не выбран', 'Москва', 'Екатеринбург']}
                onSelect={(v) => setSkladdName(v)}
                width="150px"
                style={{ marginRight: '20px' }}
              />
            )}
            <Select
              label="Статус карточки"
              select={status}
              valueFn={(v) => STATUSES_MAP[v]}
              list={['', true, false]}
              onSelect={(v) => changeStatus(v)}
              width="220px"
              style={{ marginRight: '20px' }}
            />
            {contentMode !== MODES_CONTENT_TABLE.STOCKS && (
              <Select
                label="Было удалено на вб"
                select={isDelete}
                valueFn={(v) => v.text}
                list={DELETE_LIST}
                onSelect={(v) => setIsDelete(v)}
                width="220px"
                disabled={contentMode === MODES[2] && isContentUser}
              />
            )}
          </Row>
          <Row style={{ alignItems: 'flex-start' }}>
            {contentMode === MODES_CONTENT_TABLE.STOCKS && (
              <Button
                type={TYPE_BUTTONS.WHITE}
                onClick={() =>
                  ProviderCommonApi.excelPrices({
                    data: {
                      ...params, limit: undefined
                    }
                  })}
                disabled={count > 60000}
                style={{ marginRight: '15px' }}
              >
                Скачать остатки
              </Button>
            )}

            {contentMode === MODES_CONTENT_TABLE.CONTENT && (
              <>
                <Button
                  type={TYPE_BUTTONS.WHITE}

                  onClick={() =>
                    ProviderCommonApi.excelDefault({ data: { ...params, page: undefined, limit: undefined } })
                  }
                  disabled={count > 60000}
                  style={{ marginRight: '15px' }}
                >
                  Скачать основные данные
                </Button>

                <Button
                  type={TYPE_BUTTONS.WHITE}
                  onClick={() =>
                    ProviderCommonApi.excelContent({ data: { ...params, limit: undefined } })
                  }
                  disabled={count > 60000}
                  style={{ marginRight: '15px' }}
                >
                  Скачать данные контента
                </Button>
                <Button type={TYPE_BUTTONS.BLUE} onClick={() => setContent(true)}>
                  Выгрузить данные
                </Button>
              </>
            )}
            {contentMode === MODES_CONTENT_TABLE.WB && (
              <Button
                type={TYPE_BUTTONS.WHITE}
                onClick={() =>
                  ProviderCommonApi.excelWbData({
                    data: {
                      ...params, limit: undefined, page: undefined
                    }
                  })
                }
                style={{ marginRight: '15px' }}
              >
                Скачать вб данные
              </Button>
            )}
          </Row>
        </Row>
      </WhiteBlock >
      <Table styles={styles.ozon_table}>
        <ProductsTableHeader
          providerId={providerId}
          markets={markets}
          contentMode={contentMode}
          checkAll={checkAll}
          isContentUser={isContentUser}
          isAdmin={isAdmin}
          setMarkets={setMarkets}
          isSmallProvider={isSmallProvider}
          isMinPackage={isMinPackage}
          loadProducts={loadProducts}
          clickCheckAll={clickCheckAll}
          isCityStocks={isCityStocks}
        />

        {ids.map((id) => {
          const p = byId[id];

          return (
            <ProductsTableLine
              key={id}
              product={p}
              providerId={providerId}
              contentMode={contentMode}
              isAdmin={isAdmin}
              productsSelect={productsSelect}
              isSmallProvider={isSmallProvider}
              isMinPackage={isMinPackage}
              changeProductSelect={changeProductSelect}
              onChange={onChange}
              isCityStocks={isCityStocks}
            />
          );
        })}
      </Table>
      <TablePagination num={Math.ceil(count / show) || 1} show={page} onChange={onChangePage} />

    </>
  );
};

export default ProviderProductsTable;
